import pairingsActionTypes from "./pairings.types";

export const fetchChallengePairingsStart = ({ token, challengeId }) => ({
  type: pairingsActionTypes.FETCH_CHALLENGE_PAIRINGS_START,
  payload: { token, challengeId },
});

export const fetchChallengePairingsSuccess = ({ pairs, challenge }) => ({
  type: pairingsActionTypes.FETCH_CHALLENGE_PAIRINGS_SUCCESS,
  payload: { pairs, challenge },
});

export const fetchChallengePairingsFailure = (error) => ({
  type: pairingsActionTypes.FETCH_CHALLENGE_PAIRINGS_FAILURE,
  payload: error,
});

export const fetchMyPairStatusStart = ({ token, challengeId }) => ({
  type: pairingsActionTypes.FETCH_MY_PAIR_STATUS_START,
  payload: { token, challengeId },
});

export const fetchMyPairStatusSuccess = (status) => ({
  type: pairingsActionTypes.FETCH_MY_PAIR_STATUS_SUCCESS,
  payload: status,
});

export const fetchMyPairStatusFailure = (error) => ({
  type: pairingsActionTypes.FETCH_MY_PAIR_STATUS_FAILURE,
  payload: error,
});

export const submitLosersStart = ({ token, data }) => ({
  type: pairingsActionTypes.SUBMIT_LOSERS_START,
  payload: { token, data },
});

export const submitLosersSuccess = (result) => ({
  type: pairingsActionTypes.SUBMIT_LOSERS_SUCCESS,
  payload: result,
});

export const submitLosersFailure = (error) => ({
  type: pairingsActionTypes.SUBMIT_LOSERS_FAILURE,
  payload: error,
});

export const updateLosersStart = ({ token, data }) => ({
  type: pairingsActionTypes.UPDATE_LOSERS_START,
  payload: { token, data },
});

export const updateLosersSuccess = (result) => ({
  type: pairingsActionTypes.UPDATE_LOSERS_SUCCESS,
  payload: result,
});

export const updateLosersFailure = (error) => ({
  type: pairingsActionTypes.UPDATE_LOSERS_FAILURE,
  payload: error,
});

export const submitWinnersStart = ({ token, data }) => ({
  type: pairingsActionTypes.SUBMIT_WINNERS_START,
  payload: { token, data },
});

export const submitWinnersSuccess = (result) => ({
  type: pairingsActionTypes.SUBMIT_WINNERS_SUCCESS,
  payload: result,
});

export const submitWinnersFailure = (error) => ({
  type: pairingsActionTypes.SUBMIT_WINNERS_FAILURE,
  payload: error,
});

export const updateWinnersStart = ({ token, data }) => ({
  type: pairingsActionTypes.UPDATE_WINNERS_START,
  payload: { token, data },
});

export const updateWinnersSuccess = (result) => ({
  type: pairingsActionTypes.UPDATE_WINNERS_SUCCESS,
  payload: result,
});

export const updateWinnersFailure = (error) => ({
  type: pairingsActionTypes.UPDATE_WINNERS_FAILURE,
  payload: error,
});

export const checkRoundCompletionStart = ({ token, challengeId }) => ({
  type: pairingsActionTypes.CHECK_ROUND_COMPLETION_START,
  payload: { token, challengeId },
});

export const checkRoundCompletionSuccess = (status) => ({
  type: pairingsActionTypes.CHECK_ROUND_COMPLETION_SUCCESS,
  payload: status,
});

export const checkRoundCompletionFailure = (error) => ({
  type: pairingsActionTypes.CHECK_ROUND_COMPLETION_FAILURE,
  payload: error,
});

export const setSelectedRound = (round) => ({
  type: pairingsActionTypes.SET_SELECTED_ROUND,
  payload: round,
});

export const setSelections = (selections) => ({
  type: pairingsActionTypes.SET_SELECTIONS,
  payload: selections,
});

export const clearSelections = () => ({
  type: pairingsActionTypes.CLEAR_SELECTIONS,
});

export const clearPairings = () => ({
  type: pairingsActionTypes.CLEAR_PAIRINGS,
});

export const fetchAllPairingsStart = ({ token } = {}) => ({
  type: pairingsActionTypes.FETCH_ALL_PAIRINGS_START,
  payload: { token },
});

export const fetchAllPairingsSuccess = (pairings) => ({
  type: pairingsActionTypes.FETCH_ALL_PAIRINGS_SUCCESS,
  payload: pairings,
});

export const fetchAllPairingsFailure = (error) => ({
  type: pairingsActionTypes.FETCH_ALL_PAIRINGS_FAILURE,
  payload: error,
});

export const fetchUserPairingsStart = ({ token }) => ({
  type: pairingsActionTypes.FETCH_USER_PAIRINGS_START,
  payload: { token },
});

export const fetchUserPairingsSuccess = (pairings) => ({
  type: pairingsActionTypes.FETCH_USER_PAIRINGS_SUCCESS,
  payload: pairings,
});

export const fetchUserPairingsFailure = (error) => ({
  type: pairingsActionTypes.FETCH_USER_PAIRINGS_FAILURE,
  payload: error,
});

export const fetchCreatorPairingsStart = ({ token } = {}) => ({
  type: pairingsActionTypes.FETCH_CREATOR_PAIRINGS_START,
  payload: { token },
});

export const fetchCreatorPairingsSuccess = (pairings) => ({
  type: pairingsActionTypes.FETCH_CREATOR_PAIRINGS_SUCCESS,
  payload: pairings,
});

export const fetchCreatorPairingsFailure = (error) => ({
  type: pairingsActionTypes.FETCH_CREATOR_PAIRINGS_FAILURE,
  payload: error,
});

export const verifyLosersStart = ({
  token,
  challengeId,
  moveToNextRound,
  iteration,
  round,
}) => ({
  type: pairingsActionTypes.VERIFY_LOSERS_START,
  payload: { token, challengeId, moveToNextRound, iteration, round },
});

export const verifyLosersSuccess = (result) => ({
  type: pairingsActionTypes.VERIFY_LOSERS_SUCCESS,
  payload: result,
});

export const verifyLosersFailure = (error) => ({
  type: pairingsActionTypes.VERIFY_LOSERS_FAILURE,
  payload: error,
});

export const verifyWinnersStart = ({
  token,
  challengeId,
  verifiedWinners,
  iteration,
  round,
}) => ({
  type: pairingsActionTypes.VERIFY_WINNERS_START,
  payload: { token, challengeId, verifiedWinners, iteration, round },
});

export const verifyWinnersSuccess = (result) => ({
  type: pairingsActionTypes.VERIFY_WINNERS_SUCCESS,
  payload: result,
});

export const verifyWinnersFailure = (error) => ({
  type: pairingsActionTypes.VERIFY_WINNERS_FAILURE,
  payload: error,
});

export const fetchPairsWinnersStart = ({ token, challengeId }) => ({
  type: pairingsActionTypes.FETCH_PAIRS_WINNERS_START,
  payload: { token, challengeId },
});

export const fetchPairsWinnersSuccess = (winnersData) => ({
  type: pairingsActionTypes.FETCH_PAIRS_WINNERS_SUCCESS,
  payload: winnersData,
});

export const fetchPairsWinnersFailure = (error) => ({
  type: pairingsActionTypes.FETCH_PAIRS_WINNERS_FAILURE,
  payload: error,
});
